/**
 * @param props
 */

export default (props) => {
    return {
        scroller: null,
        insider: null,
        prevStatus: false,
        nextStatus: true,
        scrollValue: 0,
        mounted() {
            this.scroller = this.$refs.scroller;
            this.insider = this.$refs.insider;
            this.grab();
        },
        prev() {
            this.nextStatus = true;
            this.scrollValue = this.scrollValue + 180;
            if (this.scrollValue >= 0) {
                this.prevStatus = false;
                this.scrollValue = 0;
            }
            this.apply();
        },
        next() {
            this.prevStatus = true;
            this.scrollValue = this.scrollValue - 180;
            if (this.insider.offsetWidth - this.scroller.offsetWidth <= Math.abs(this.scrollValue)) {
                this.nextStatus = false;
                this.scrollValue = -Math.abs(this.insider.offsetWidth - this.scroller.offsetWidth);
            }
            this.apply();
        },
        apply() {
            this.insider.style.transform = 'translateX(' + this.scrollValue + 'px)';
        },

        grab() {

            let pos = { top: 0, left: 0, x: 0, y: 0 };

            this.scroller.style.cursor = 'grab';

            const mouseDownHandler = (e) => {
                this.scroller.style.cursor = 'grabbing';
                this.scroller.style.Select = 'none';

                pos = {
                    left: this.scroller.scrollLeft,
                    top: this.scroller.scrollTop,
                    // Get the current mouse position
                    x: e.clientX,
                    y: e.clientY,
                };

                document.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);
            };

            const mouseMoveHandler = (e) => {
                // How far the mouse has been moved
                const dx = e.clientX - pos.x;
                const dy = e.clientY - pos.y;

                // Scroll the element
                this.scroller.scrollTop = pos.top - dy;
                this.scroller.scrollLeft = pos.left - dx;
            };

            const mouseUpHandler = () => {
                this.scroller.style.cursor = 'grab';
                this.scroller.style.removeProperty('-select');

                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);

                this.prevStatus = this.scroller.scrollLeft > 0;
                this.apply();

            };

            // Attach the handler
            this.scroller.addEventListener('mousedown', mouseDownHandler);
        }
    }
};